import React from 'react';
import { formatSizeUnits } from '../../utils/utils';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { Button } from 'ui';

const AttachEntry = ({ guid, name, size, onRemove }) => {
  const { t } = useTranslation();

  return (
    <div className="upload-attach__entry">
      <div className="upload-attach__entry-left">
        <div className="upload-attach__entry-name">{name}</div>
        <div className="upload-attach__entry-size">{formatSizeUnits(size)}</div>
      </div>
      <div className="upload-attach__entry-right">
        <Button
          ariaLabel={t('actions:Delete file', { name })}
          className="upload-attach__entry-remove"
          isIconOnly
          leftIcon="close"
          onClick={() => onRemove(guid)}
          variant="plain"
        />
      </div>
    </div>
  );
};

AttachEntry.propTypes = {
  guid: PropTypes.string,
  name: PropTypes.string,
  onRemove: PropTypes.func,
  size: PropTypes.number,
};

AttachEntry.defaultProps = {
  guid: '1',
  name: 'test',
  size: 100,
  onRemove: () => {},
};

export default AttachEntry;
